import { memo, useEffect } from 'react'
import { observer } from 'mobx-react'
import { useStores } from 'stores/utils/hooks/useStores'
import useDecision from 'utils/tracking/optimizely/useDecision'
import { Experiments } from 'OptimizelyProvider'

interface ToggleHandleSubmit {
  handleSubmit: any
}

const PATHS_NAMES_WITH_NO_DEFAULT_VALUES = [
  'debtors.count',
  'debtors.primary.personal.civilStatus',
  'debtors.secondary.personal.civilStatus',
  'debtors.primary.household.livingSituation',
  'debtors.secondary.household.livingSituation',
  'debtors.primary.realEstate.rentalProperty.type',
  'debtors.secondary.realEstate.rentalProperty.type'
]

const PATHS_WITH_UNDEFINED_VALUES = PATHS_NAMES_WITH_NO_DEFAULT_VALUES.map(
  (path: string) => ({
    path,
    value: undefined
  })
)

const ToggleHandleSubmit = observer(
  ({ handleSubmit }: ToggleHandleSubmit): null => {
    const {
      page: { toggleHandleSubmit, setToggleHandleSubmit },
      traversal: { handleMultiplePathFormFieldChanges }
    } = useStores()

    const decisionResult = useDecision(Experiments.CAT_1024_AUTOMATIC_WEITER)
    const variationKey = decisionResult?.[0].variationKey
    const isVariation2 = variationKey === 'variation_2'

    // override default values with no (undefined) values
    useEffect(() => {
      if (isVariation2) {
        handleMultiplePathFormFieldChanges(PATHS_WITH_UNDEFINED_VALUES, false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVariation2])

    // call a function when `toggleHandleSubmit` is triggered
    useEffect(() => {
      if (toggleHandleSubmit) {
        setToggleHandleSubmit(false)

        if (isVariation2) {
          handleSubmit()
        }
      }
    }, [handleSubmit, toggleHandleSubmit, setToggleHandleSubmit, isVariation2])

    return null
  }
)

export default memo(ToggleHandleSubmit)
